import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";

import MapView from './MapView';
import BookmarkButton from './BookmarkButton';

import config from './../config';
import { latLng } from 'leaflet';

class OrnefniView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/ornefni/';

		this.state = {
		};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.id) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.match.params.id != prevProps.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		let params = [];

		this.setState({
			loading: true,
			listLoading: true
		});

		fetch(this.url+this.props.match.params.id+'/')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json,
					loading: false
				});
			}.bind(this));
	}

	render() {
		let item = this.state.data;

		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					<div className={'column-content'+(this.state.loading ? ' loading' : '')}>
						{
							item &&
							<React.Fragment>

								{/*
								<BreadCrumbs path={[
									{
										path: '/einstaklingar/',
										title: 'Einstaklingar'
									},
									{
										path: item.id,
										title: item.nafn
									}
								]} />
								*/}

								<h3>
									{item.ornefni}
								</h3>
								<hr/>


								<div className="row">

									<div className="col col-md-6">
										<h5>Tengdar örnefnaskrár</h5>

										<table className={'table'+(this.state.listLoading && true == false ? ' loading' : '')}>
											<thead>
												<tr>
													<th>Titill</th><th></th>
												</tr>
											</thead>
											<tbody>
												{
													item.ornefnaskrar && item.ornefnaskrar.length > 0 &&
													item.ornefnaskrar.map((skra, index) => <React.Fragment key={index}>
														<tr>
															<td><Link to={'/ornefnaskra/'+skra.ornefnaskra.id}>{skra.ornefnaskra.titill}</Link></td><td><BookmarkButton title={skra.ornefnaskra.titill} id={skra.ornefnaskra.id} baer={null} baer_id={null} type={'skra'} className="small" /></td>
														</tr>
														{
															skra.skra_texti && <tr className="borderless">
																<td><div dangerouslySetInnerHTML={{__html: skra.skra_texti}} /></td>
															</tr>
														}

													</React.Fragment>)
												}
											</tbody>
										</table>

									</div>

									<div className="col col-md-6">
										{
											((item.lat && item.lng) || item.uuid) && 
											<MapView ref={this.mapView}
												viewInTabs={true}
												selectedTab={this.state.selectedTab}
												mapData={item.lat && item.lng ? [{
													id: item.id,
													label: item.ornefni,
													type: 'farm',
													latLng: [item.lat, item.lng]
												}] : []}
												overlayListData={this.state.mapListData}
												overlayVisible={true}
												featureData={item.uuid ? [item.uuid] : []}
											></MapView>
										}
									</div>

								</div>

							</React.Fragment>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(OrnefniView);



// WEBPACK FOOTER //
// ./src/components/OrnefniView.js